import CareerPostPurchaseBanner from './CareerPostPurchaseBanner'
export default CareerPostPurchaseBanner
